import { render, staticRenderFns } from "./InfoPointVolunteers.vue?vue&type=template&id=d58bbaea&"
import script from "./InfoPointVolunteers.vue?vue&type=script&lang=js&"
export * from "./InfoPointVolunteers.vue?vue&type=script&lang=js&"
import style0 from "./InfoPointVolunteers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports